export default "__VITE_ASSET__fAvsva2x__"